export default __webpack_public_path__ + "static/media/avatar_fairy_pixie4.7b07196d.mp3";